import NameField from './Fields/PatientData/NameField.vue';
import SurnameField from './Fields/PatientData/SurnameField.vue';
import EmailField from './Fields/PatientData/EmailField.vue';
import PhoneField from './Fields/PatientData/PhoneField.vue';
import AddressField from './Fields/PatientData/AddressField.vue';
import CityField from './Fields/PatientData/CityField.vue';
import ZipCodeField from './Fields/PatientData/ZipCodeField.vue';
import PeselField from './Fields/PatientData/PeselField.vue';
import HomeNumberField from './Fields/PatientData/HomeNumberField.vue';
import NewPeselField from './Fields/PatientData/NewPeselField.vue';


export default {
  __name: 'PatientData',
  props: {
    hasOldPesel: {
        type: Boolean,
        default: false,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;



const __returned__ = { props, NameField, SurnameField, EmailField, PhoneField, AddressField, CityField, ZipCodeField, PeselField, HomeNumberField, NewPeselField }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}